var moment = require('moment')
moment.locale('pt-br');
import authentication from '../api/authentication'
import decodeApi from '../api/decode'
import serviceCatalogApi from '../api/service-catalog'
import analyze from '../api/analyze'

export default{
    async verifyAuth(token){ // funcao verifica se o usuario está autenticado no authentication service
        try {
            const tokenReq = await authentication.get(`/users/verify-token-authentication?token=` + token)
            // console.log("tokenReq GET: ", tokenReq.data)
            return true
        } catch (errorGET) {
            //TODO: make a error message showing up instead console.log error
            // console.log("not auth GET: ", errorGET)
            try {
                const tokenReq = await authentication.post("/verify?token=" + token)
                // console.log("tokenReq POST: ", tokenReq.data)
                return true
            } catch (errorPOST) {
                //TODO: make a error message showing up instead console.log error
                // console.log("not auth POST: ", errorPOST)
                return false
            }
        }
    },
    async verifySchedule(uid, workspaceId){ // funcao verifica se o usuario esta agendado
        let status = ''
        await decodeApi.get(`/schedulings?userId=${uid}&workspaceId=${workspaceId}`)
            .then(async response => {
                let schedulings = response.data.schedulings
                if(Array.isArray(schedulings) && schedulings.length > 0) schedulings = schedulings[schedulings.length - 1]
                // console.log("GET schedulings: ", schedulings)
                localStorage.setItem('scheduling', JSON.stringify(response.data))
                localStorage.setItem('schedulingId', schedulings.id)
                localStorage.setItem('sessionSchedule', schedulings.fields.sessionId)
                status = await this.statusScheduling(schedulings)
                status.sessionId = schedulings.fields.sessionId
            }).catch(error => { // retorna {{dashboard}} se o usuario nao tem agendamento
                status = {'name' : 'dashboard', 'status' : 'not scheduled'}
                //TODO: make a error message showing up instead console.log error
                // console.error("error trying to get schedulings: ", error)
            })
        return status
    },
    async statusScheduling(schedulings){ // funcao verifica o status do agendamento
        let { data: serverNow } = await decodeApi.get(`/schedulings?userId=${localStorage.getItem("userId")}&workspaceId=${localStorage.getItem("workspaceId")}&now=${true}`)
        let lastScheduling = schedulings
        if(schedulings.length > 0){
            lastScheduling = await schedulings.reduce(function(a,b){
                return a.fields.createdAt > b.fields.createdAt ? a : b
            })
        }
        let diffScheduling = moment(lastScheduling.session.schedule).diff(serverNow.now, 'minutes')
        if(diffScheduling >= 10){ // diff maior que 10, a sessão não comecou
            return {'name' : 'dashboard', 'status' : 'coming soon', 'schedule' : lastScheduling.session.schedule} 
        }
        if(diffScheduling <= -10){ // diff menor que -10, a sessão expirou
            return {'name' : 'dashboard', 'status' : 'expired', 'schedule' : lastScheduling.session.schedule} 
        }
        if(diffScheduling <= 9 && diffScheduling >= - 9){ // diff entre -9 e 9, a sessão está aberta
            return {'name' : 'dashboard', 'status' : 'started', 'schedule' : lastScheduling.session.schedule} 
        }
    },
    redirectAuth(){
        let workspaceId = localStorage.getItem('workspaceId')
        location.href = `${process.env.VUE_APP_HOST_AUTHENTICATION_FRONT}/logout?workspaceId=${workspaceId}`
    },
    objectRedirectGame(status){
        switch(status){
            case 'started' : 
                return {name : 'game-enigma'}
            case 'timeout' :
                return {name : 'final-team', params : {typeFinish : 'timeout'}}
            case 'score-finished':
                return {name : 'final-team', params : {typeFinish : 'score-finished'}}
        }
    },
    async getPlayerInfo(userId){
        try {
            const playerResponse = await authentication.get(`/users/${userId}`)
            // console.log(playerResponse)
            const { id, name, email, cpf } = playerResponse.data
            return { id, name, email, cpf }
            
        } catch (error) {
            //TODO: make a error message showing up instead console.log error
            // console.log(error.response)
        }
    },
    async getWorkspace(workspaceId){
        try {
            const response = await serviceCatalogApi.get(`/workspaces/${workspaceId}`)
            // console.log(response.data.workspace)
            return response.data.workspace
        } catch (error) {
            //TODO: make a error message showing up instead console.log error
            // console.log(error)
        }
    },
    async hostFunction(hostIndex, api, method, route){
        const timeToAction = hostIndex * 5000
        // console.log(timeToAction)
        setTimeout(async function(){ 
            // console.log('entrou')
            const response = await api[method](route) 
            // console.log(response)
        }, timeToAction);
    },
    async verifyTeamGame(statusSchedule, teamGameId, userId, workspaceId){
        let sessionId = localStorage.getItem('sessionSchedule')
        if(statusSchedule.status != 'started' && statusSchedule.status != 'coming soon' && statusSchedule.status != 'not scheduled'){
            let status = ''
            // console.log("teamGameId", teamGameId)
            try {
                if(teamGameId){
                    const responseGame = await decodeApi.get(`/team-games/${teamGameId}`)
                    // console.log(responseGame)
                    status = responseGame.data.teamGame.status
                }else{
                    const responseTG = await decodeApi.get(`/team-games/by-user?userId=${userId}&sessionId=${sessionId}`)
                    // console.log(responseTG)
                    status = responseTG.data.teamGame.status
                }
                // console.log(status)
                if(status == 'started' || status == 'in progress'){
                    statusSchedule.status = 'in progress'
                }
                if(status == 'timeout' || status == 'hit' || status == 'zero score'){
                    statusSchedule.status = 'finished'
                    const response = await analyze.get(`/decode-reports?userId=${userId}&workspaceId=${workspaceId}`)
                    let hasReport = false 
                    if(response.data.decodeReport) hasReport = Boolean(response.data.decodeReport.id)
                    localStorage.setItem('hasReport', JSON.stringify(hasReport))
                    if(hasReport) statusSchedule.status = 'report'
                } 
            } catch (error) {
                //TODO: make a error message showing up instead console.log error
                // console.log(error)
            } 
        }

        // console.log(statusSchedule)
        return statusSchedule
    }
}

    

